import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { BASE_URL } from "../../utils/BaseUrl"
import httpRequest from "../../utils/httpsRequest";


export const fetchTransactions = createAsyncThunk(
  "transaction/fetchTransactions",
  async (arg) => {
      return httpRequest(`${BASE_URL}/Transactions?PaymentStatus=${arg.paymentStatus}&Date=${arg.date}&SearchText=${arg.searchText}&PageSize=${arg.pageSize}&PageNumber=${arg.pageNumber}`);
  }
)

const transactionSlice = createSlice({
  name: 'transaction',
  initialState: {
    transaction: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTransactions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTransactions.fulfilled, (state, action) => {
        state.loading = false;
        state.transaction = action.payload;
      })
      .addCase(fetchTransactions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export default transactionSlice.reducer;
